import { render, staticRenderFns } from "./AddNew.vue?vue&type=template&id=f79ed54e&scoped=true"
import script from "./AddNew.vue?vue&type=script&lang=ts"
export * from "./AddNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79ed54e",
  null
  
)

export default component.exports